import { v4 } from 'uuid';
import { Component } from '../components/common/component';
import { IModal } from '../shared/interfaces/modals/modal.interface';

export type TemplateOptions = {
    content?: string,
    title?: string,
    acceptText?: string,
    modalClass?: string,
    unCancellable?: boolean,
    dismissible?: boolean,
};

export class SimpleModal extends Component implements IModal {
    public static create(templateOptions: TemplateOptions) {
        /* eslint-disable max-len */
        const container = $(`
            <div id="${v4()}" class="simple-modal ${templateOptions.modalClass ?? ''}">
                <div class="simple-modal__heading">
                    <div>${templateOptions.title ?? ''}</div>
                    ${templateOptions?.dismissible ? '<i class="lni lni-close simple-modal__close"></i>' : ''}
                </div>
                <div class="simple-modal__content">
                    ${templateOptions?.content ?? ''}
                </div>
                <div class="simple-modal__footer">
                    ${!templateOptions.unCancellable ? `<button type="button" class="button secondary-button-style simple-modal__close">${$.i18n('cancel')}</button>` : ''}
                    <button type="button" class="button primary-button-style simple-modal__accept">${templateOptions?.acceptText ?? $.i18n('accept')}</button>
                </div>
            </div>
        `);

        return new this(container);
    }

    private _overlay: JQuery | undefined;

    public constructor(container: JQuery) {
        super(container);

        $('body')
            .append(container);

        this._addEventListeners();
    }

    public get isOpen() {
        return this._container.hasClass('simple-modal--open');
    }

    public close(): void {
        this._container.removeClass('simple-modal--open');

        setTimeout(() => {
            this._overlay?.remove();

            this._overlay = undefined;

            $('body')
                .css('overflow', '');
        }, 300);

        this.dispatch('close');

        this._container.css('display', 'none');
    }

    public open(...args: any): void {
        $('body')
            .css('overflow', 'hidden');

        this._container.css('display', 'block');

        requestAnimationFrame(() => {
            this._container.addClass('simple-modal--open');

            this._createOverlay();

            this._calculateZIndex();
        });

        this.dispatch('open');
    }

    private _createOverlay() {
        this._overlay = $('<div class="simple-modal__overlay"></div>');

        this._overlay.on('click', (e) => {
            if (e.target.classList.contains('simple-modal__overlay')) {
                this.close();
            }
        });

        this._overlay.css('min-height', `${window.innerHeight}px`);

        $('body')
            .append(this._overlay);
    }

    private _calculateZIndex() {
        const zIndex = $('.simple-modal__overlay').length + 1010;

        this._overlay?.css('z-index', zIndex);
        this._container.css('z-index', zIndex + 1);
    }

    protected _addEventListeners(): void {
        this._container.find('.simple-modal__close')
            .on('click', this._onModalCloseClick.bind(this));
        this._container.find('.simple-modal__accept')
            .on('click', this._onModalAcceptClick.bind(this));

        window.document.addEventListener('keydown', (e: KeyboardEvent) => {
            if (e.code === 'Escape') this.close();
        });
    }

    private _onModalAcceptClick() {
        this.dispatch('accept');
        this.close();
    }

    private _onModalCloseClick() {
        this.close();
    }
}
